import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Image } from '@blueprint/image';
import { ShareiosSmall } from '@blueprint/icons';

export const SavedListingCardFooter = styled('div')(
    ({ theme: { spacing } }) => css`
        display: flex;
        flex-direction: row;
        height: 4.25rem;
        justify-content: space-between;
        padding: 0.75rem ${spacing['16px']};
    `
);

export const StyledBranchLogo = styled(Image)(
    ({ theme: { spacing } }) => css`
        height: 2.5rem;
        margin-right: ${spacing['16px']};
        width: auto;
    `
);

export const FooterSection = styled('div')(css`
    align-items: center;
    display: flex;
    flex-direction: row;
`);

export const ShareiosSmallColored = styled(ShareiosSmall)(
    ({ theme: { colors } }) => css`
        color: ${colors['purple-bright']};
    `
);

export const Text = styled('p')(
    ({ theme }) => css`
        margin: 0;
        line-height: ${theme.type.size8LineHeight};
        font-size: ${theme.type['8']};
        color: ${theme.colors['purple-dark']};
    `
);
